export default "console.log('hello world');\nconsole.log(\"hello world\");\nconst hello = \"hey\";\nconsole.log(`${hello} world`);"